var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgThermostat = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 10.8332V4.1665C12.4999 2.78317 11.3833 1.6665 9.99992 1.6665C8.61659 1.6665 7.49992 2.78317 7.49992 4.1665V10.8332C6.49159 11.5915 5.83325 12.8082 5.83325 14.1665C5.83325 16.4665 7.69992 18.3332 9.99992 18.3332C12.2999 18.3332 14.1666 16.4665 14.1666 14.1665C14.1666 12.8082 13.5083 11.5915 12.4999 10.8332ZM9.16659 4.1665C9.16659 3.70817 9.54159 3.33317 9.99992 3.33317C10.4583 3.33317 10.8333 3.70817 10.8333 4.1665H9.99992V4.99984H10.8333V6.6665H9.99992V7.49984H10.8333V9.1665H9.16659V4.1665Z",
    fill: "#E8472E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThermostat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thermostat.5e8af320.svg";
export { ForwardRef as ReactComponent };